



















import { Component, Vue } from "vue-property-decorator";
import { Observer } from "mobx-vue";
import requestStore from "@/store/requestStore";

@Observer
@Component
export default class RequestCreateBinDetails extends Vue {
  headers = [
    { text: "Waste Stream", value: "wasteStream" },
    { text: "Bin Size", value: "binSize" },
    { text: "Day / Week", value: "dayWeek" }
  ];

  requestStore = requestStore;
}
